import type { TimeResult } from '../calendar.types'

import { cs } from '../../utils'
import { CalendarItem as MonthItem, CalendarItemsContainer } from '../calendar.styles'
import { monthsShort } from '../consts'

type MonthPickerProps = {
  calendar: TimeResult
  onSelectMonth?: (date: Date) => void
}

export const MonthPicker = ({ calendar, onSelectMonth }: MonthPickerProps) => (
  <CalendarItemsContainer className={cs('vui-month-picker')} gridTemplateRows="repeat(4, 65px)">
    {calendar.items.map(item => (
      <MonthItem
        fontWeight={500}
        key={item.date.getTime()}
        onClick={(!item.isDisabled && onSelectMonth?.(item.date)) || undefined}
        {...item}
        alignContent="center"
        textAlign="center"
      >
        {monthsShort[item.date.getUTCMonth()]}
      </MonthItem>
    ))}
  </CalendarItemsContainer>
)
